(function($) {
  // update ingredients on sku select for mobile
  $(document).on('sku:select', function(e, skuData) {
    e.preventDefault();
    setIngredientsHTML(skuData, $(this));
  });
  function getSku(skuID) {
    var skus = page_data['catalog-spp']['products'][0].skus;
    for (var i in skus) {
      if (skuID === skus[i].SKU_BASE_ID) {
        return skus[i];
      }
    }
  }
  function setIngredientsHTML(skuData, $context) {
    var isSPP = $('body').hasClass('page-product');
    var sku;
    var skuIngredients;
    var $ingredientsContent;
    var skuIngredientsFormatted;
    if (isSPP) {
      sku = getSku(parseInt(skuData.SKU_BASE_ID));
      $ingredientsContent = $('.js-ingredients', $context);
      skuIngredients = sku.ILN_LISTING;
      skuIngredientsFormatted;
      if (!!skuIngredients) {
        skuIngredientsFormatted = skuIngredients.slice(12, skuIngredients.length - 1);
        $ingredientsContent.html(skuIngredientsFormatted);
      }
    }
  }
  //update ingredients on sku select for pc
  $(document).ready(function() {
    var $product = $('.module-spp-detail, .js-spp-content', $(this));
    $product.on('selectSku', function(i, skuData) {
      setIngredientsHTML(skuData, $(this));
    });
    $product.on('skuSelect:ingredients', function(i, skuData) {
      setIngredientsHTML(skuData, $(this));
    });
  });
})(jQuery);
